import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function usePropertyWaterConsumptionPercentageMonthly(
  options,
  key = "getPropertyWaterConsumptionPercentageMonthly",
) {
  const axiosPrivate = useAxiosPrivate();

  const getPropertyWaterConsumptionPercentageMonthly = async () => {
    const events = await axiosPrivate({
      method: "GET",
      url: "Property/WaterConsumptionPercentage/Monthly",
    }).then((res) => res.data);
    return events;
  };

  return useQuery([key], () => getPropertyWaterConsumptionPercentageMonthly(), {
    ...options,
  });
}

export default usePropertyWaterConsumptionPercentageMonthly;
